/**
 * This modal will be responsible for showing error, success, and information on a modal
 */

import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CtaComponent from "../cta";
import { CTA_TYPE, CTA_SIZE, MESSAGE_TYPE } from "../../../data/constants";
import "./style.scss";
import SuccessIcon from "../../../assets/images/ic-success.svg";
import ErrorIcon from "../../../assets/images/ic-error.svg";
import WarningIcon from "../../../assets/images/ic-warning.svg";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "1px solid #707070",
  boxShadow: 24,
  p: 4,
};

interface Props {
  mainText?: string;
  subText?: string;
  open: boolean;
  modalType: string;
  handleClose: any;
}

export default function ApiStateModal(props: Props) {
  const { subText, open, modalType, handleClose, mainText } = props;

  const getCustomTextColor = (): string => {
    switch (modalType) {
      case MESSAGE_TYPE.success:
        return "text-[#56B78B]";
      case MESSAGE_TYPE.error:
        return "text-[#BF6666]";
      default:
        return "text-[#DBAD4E]";
    }
  };

  const getImagePath = (): string => {
    switch (modalType) {
      case MESSAGE_TYPE.success:
        return SuccessIcon;
      case MESSAGE_TYPE.error:
        return ErrorIcon;
      default:
        return WarningIcon;
    }
  };

  const getMainText = () => {
    switch (modalType) {
      case MESSAGE_TYPE.success:
        return "Success";
      case MESSAGE_TYPE.error:
        return "Error";
      default:
        return "Warning";
    }
  };

  return (
    <div>
      <Modal
        keepMounted={false}
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          className={`basic-modal-container flex justify-center items-center flex-col rounded-[6px] border-[0]
          ${getCustomTextColor()} w-[520px] sm:w-full sm:min-w-0 h-[268px] sm:top-auto sm:right-0 sm:left-0 sm:bottom-0
          sm:translate-x-0 sm:translate-y-0 sm:rounded-b-[0]
        `}
        >
          <img src={getImagePath()} alt=""></img>
          <Box component="p" className="text-18 font-bold mb-12 mt-18 ">
            {mainText ? mainText : getMainText()}
          </Box>
          <Box component="p" className="text-15 font-normal mb-5 text-center">
            {subText}
          </Box>
          <CtaComponent
            customClass="absolute right-16 bottom-16"
            ctaSize={CTA_SIZE.medium}
            ctaType={CTA_TYPE.active_cta}
            ctaText={"OK"}
            onCtaClick={handleClose}
          ></CtaComponent>
        </Box>
      </Modal>
    </div>
  );
}
